<template>
  <section class="why-choose-sogdo">
    <div class="container">
      <div class="choose-header">
        <h2 class="choose-title">
          <span class="text-white">{{ headerData.titlePart1 }}</span>
          <span class="text-gradient">{{ headerData.titlePart2 }}</span>
        </h2>
        <p class="choose-subtitle">{{ headerData.subtitle }}</p>
      </div>
      
      <div class="choose-grid">
        <div 
          v-for="(card, index) in chooseCards" 
          :key="index"
          class="choose-card wow fadeInUp" 
          :data-wow-delay="`${(index + 1) * 0.1}s`"
        >
          <div class="card-icon">
            <i :class="card.icon"></i>
          </div>
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-description">{{ card.description }}</p>
          <div class="card-stats">
            <div class="stat">
              <span class="stat-number">{{ card.stat.number }}</span>
              <span class="stat-label">{{ card.stat.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WhySogdoItsWhyChooseComp",
  props: {
    headerData: {
      type: Object,
      required: true,
      default: () => ({
        titlePart1: "Why Choose",
        titlePart2: "Sogdo?",
        subtitle: "Discover the unique advantages that make Sogdo the perfect partner for your digital transformation journey."
      })
    },
    chooseCards: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Why Choose Sogdo Section */
.why-choose-sogdo {
  padding: 100px 0;
  background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%);
  position: relative;
  overflow: hidden;
}

.choose-header {
  text-align: center;
  margin-bottom: 80px;
}

.choose-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.text-gradient {
  background: linear-gradient(135deg, #F6EC4F, #FB0E76);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.choose-subtitle {
  font-size: 20px;
  color: #ccc;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.choose-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.choose-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.2);
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.choose-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(246, 236, 79, 0.1), transparent);
  transition: left 0.5s ease;
}

.choose-card:hover::before {
  left: 100%;
}

.choose-card:hover {
  transform: translateY(-10px);
  border-color: #F6EC4F;
  box-shadow: 0 20px 40px rgba(246, 236, 79, 0.2);
}

.choose-card .card-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 25px;
  background: linear-gradient(135deg, #F6EC4F, #FB0E76);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #fff;
  transition: all 0.3s ease;
}

.choose-card:hover .card-icon {
  transform: scale(1.1);
}

.choose-card .card-title {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.choose-card .card-description {
  font-size: 16px;
  color: #ccc;
  line-height: 1.6;
  margin-bottom: 25px;
}

.choose-card .card-stats {
  display: flex;
  justify-content: center;
}

.choose-card .stat {
  text-align: center;
}

.choose-card .stat-number {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: #F6EC4F;
  font-family: 'Archivo', sans-serif;
}

.choose-card .stat-label {
  display: block;
  font-size: 14px;
  color: #ccc;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 5px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .choose-title {
    font-size: 36px;
    flex-direction: column;
    gap: 10px;
  }
  
  .choose-subtitle {
    font-size: 16px;
  }
  
  .choose-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  
  .choose-card {
    padding: 30px 20px;
  }
  
  .choose-card .card-icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .choose-card .card-title {
    font-size: 20px;
  }
  
  .choose-card .card-description {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .choose-title {
    font-size: 28px;
  }
  
  .choose-subtitle {
    font-size: 14px;
  }
  
  .choose-card {
    padding: 25px 15px;
  }
  
  .choose-card .card-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  
  .choose-card .card-title {
    font-size: 18px;
  }
  
  .choose-card .card-description {
    font-size: 13px;
  }
  
  .choose-card .stat-number {
    font-size: 24px;
  }
}
</style>
